export default function formatDate(value) {
  if (!value) return '';
  const [y, m, d] = value.split(' ')[0].split('-');
  return d ? `${d}.${m}.${y}` : value;
}
